import * as React from 'react';
import classNames from 'classnames';

import { EAppService } from '../../types/appService';

import * as styles from './CianGroup.css';
import * as gridStyles from '../../utils/grid.css';

interface ICianGroupProps {
  onDownloadAppClick(event: React.MouseEvent<HTMLAnchorElement>, appService: EAppService): void;
}

export const CianGroup: React.FC<ICianGroupProps> = ({ onDownloadAppClick }) => (
  <div className={classNames(styles['c-footer-group'], gridStyles['cg-col-24'])}>
    <div className={styles['c-footer-asterisk']}>
      <div className={styles['c-footer-group-logo']} />
      Лидер онлайн-недвижимости России&#42;
      <br />
      <span className={styles['c-footer-asterisk-text']}>
        &#42; по количеству посещений сайта cian.ru пользователями сети Интернет по данным LiveInternet в разделе
        «Недвижимость» по состоянию на 12 марта 2020 г.
      </span>
    </div>
    <div className={styles['c-footer-group-mobile']}>
      Мобильное приложение ЦИАН:
      <a
        href="http://m.onelink.me/1229ee8d"
        target="_blank"
        rel="nofollow noreferrer"
        className={classNames(styles['c-footer-group-mobile-button'], styles['c-footer-group-mobile-apple-btn'])}
        onClick={event => onDownloadAppClick(event, EAppService.AppStore)}
      />
      <a
        href="http://m.onelink.me/318c04d5"
        target="_blank"
        rel="nofollow noreferrer"
        className={classNames(styles['c-footer-group-mobile-button'], styles['c-footer-group-mobile-google-btn'])}
        onClick={event => onDownloadAppClick(event, EAppService.GooglePlay)}
      />
      <a
        href="https://appgalleryhuawei.onelink.me/9VFh/3e171a2b"
        target="_blank"
        rel="nofollow noreferrer"
        className={classNames(styles['c-footer-group-mobile-button'], styles['c-footer-group-mobile-huawei-btn'])}
        onClick={event => onDownloadAppClick(event, EAppService.AppGallery)}
      />
    </div>
  </div>
);
